import React, { Fragment } from "react";
import { hideNotification, setEvaded } from "../reducers/apartments";
import { connect } from "react-redux";

class TableBottom extends React.Component {
  render() {
    const style = {
      border: "solid",
      borderWidth: 1,
    };
    // console.log("footer props", this.props);
    return (
      <Fragment>
        <div style={{ display: "flex", marginTop: -1, height: "3.6vh" }}>
          <div
            style={{
              border: "solid",
              borderWidth: 1,
              width: "calc(33vw - 7px)",
              paddingLeft: 16,
              display: "flex",
              alignItems: "center",
            }}
          >
            {`Data Ordine: ${formatDate(this.props.servizio.createdAt)}`}
          </div>
          <div
            style={{
              border: "solid",
              borderWidth: 1,
              marginLeft: -1,
              width: "calc(6vw + 1px)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            Evaso?
          </div>
          <button
            style={{
              border: "solid",
              borderWidth: 1,
              marginLeft: -1,
              width: "calc(6vw + 0px)",
              cursor: "pointer",
              backgroundColor: "#FFEF85",
              boxShadow: "2px 2px 2px 0px rgba(0,0,0,0.4)",
            }}
            onClick={() => this.props.setEvaded(this.props.id, true)}
          >
            Sì
          </button>
          <button
            style={{
              border: "solid",
              borderWidth: 1,
              marginLeft: -1,
              width: "calc(6vw + 2px)",
              cursor: "pointer",
              backgroundColor: "#FFEF85",
              boxShadow: "2px 2px 2px 0px rgba(0,0,0,0.4)",
            }}
            onClick={() => this.props.setEvaded(this.props.id, false)}
          >
            No
          </button>
        </div>
      </Fragment>
    );
  }
}

const convertToLocalHours = (rawDate) => {
  const date = new Date(rawDate);
  // console.log("cane", date.toISOString());
  const offsetHours = date.getTimezoneOffset() / 60;
  const currentHours = date.getUTCHours();
  const copy = new Date(date);
  copy.setUTCHours(currentHours - offsetHours);
  // console.log("caneblu", copy.toISOString());
  return copy;
};

const formatDate = (date) => {
  const iso = convertToLocalHours(date).toISOString();
  return (
    iso[8] +
    iso[9] +
    "/" +
    iso[5] +
    iso[6] +
    "/" +
    iso[0] +
    iso[1] +
    iso[2] +
    iso[3] +
    " " +
    iso[11] +
    iso[12] +
    iso[13] +
    iso[14] +
    iso[15]
  );
};

export default TableBottom;
